/*
* テキストのコピー
*/
export default class TextCopy {
  constructor() {
    this.$targetTexts = document.querySelectorAll('[data-target="targetText"]');
    this.$copyButtons = document.querySelectorAll('[data-target="copyButton"]');
  }

  attachEvent() {
    const targetTexts = Array.from(this.$targetTexts, targetText => targetText.textContent);

    this.$copyButtons.forEach((copyButton, index) => {
      copyButton.addEventListener('click', () => {
        const targetText = targetTexts[index];
        return navigator.clipboard.writeText(targetText).then(() => {
          alert('コピーしました。');
        });
      });
    });
  }
}
